import * as reportTypes from 'core/constants/report-type';
import { EntitySectionTypes, ReportTypes } from 'core/constants/report-type';

export function translateEntitySectionToEntityType(
  selectedEntitySection: EntitySectionTypes,
): ReportTypes {
  switch (selectedEntitySection) {
      case reportTypes.ENTITY_SECTION_BILLBOARD:
          return 'Billboard';
      case reportTypes.ENTITY_SECTION_CHAIN:
          return 'Chain';
      case reportTypes.ENTITY_SECTION_PROPERTY:
          return 'Property';
      case reportTypes.ENTITY_SECTION_MARKET:
      case reportTypes.ENTITY_SECTION_INDUSTRY:
          return 'Market';
      default:
          throw new Error(
              `translateEntitySectionToEntityType: Unknown entity section: ${selectedEntitySection}`,
          );
  }
}